// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__UMYJS","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__kBmcf"};